// Groessenhilfe (snippets/su-size-help.liquid): oeffnet und schliesst das dialog-Element mit Animation.
// Schliessen per Kreuz, Escape, Klick neben das Fenster und auf Mobil per Herunterziehen am Griff oder Kopf
// (auch aus dem Inhalt heraus, wenn er ganz oben steht). Seite dahinter scrollt nicht mit.
(() => {
  if (window.__suSizeHelp) return;
  window.__suSizeHelp = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');

  // Zeigt an, dass unten noch Inhalt folgt (Desktop: Maske am Inhalt, Mobil: Verlauf am Sheet)
  const fade = (dialog) => {
    const body = dialog.querySelector('[data-su-sizehelp-body]');
    if (!body) return;
    const more = body.scrollTop + body.clientHeight < body.scrollHeight - 4;
    body.classList.toggle('has-more', more);
    dialog.querySelector('.su-sizehelp__panel').classList.toggle('has-more', more);
  };

  function open(dialog) {
    if (dialog.open) return;
    dialog.classList.remove('is-closing');
    dialog.showModal();
    document.body.classList.add('overflow-hidden');
    const body = dialog.querySelector('[data-su-sizehelp-body]');
    if (body) {
      // Fokus auf den Inhalt statt auf das Kreuz, sonst zeigt Safari einen Rahmen um das Kreuz
      body.setAttribute('tabindex', '-1');
      body.focus({ preventScroll: true });
      body.scrollTop = 0;
      if (!body.dataset.bound) {
        body.dataset.bound = '1';
        body.addEventListener('scroll', () => fade(dialog), { passive: true });
        bindDrag(dialog);
      }
    }
    requestAnimationFrame(() => {
      fade(dialog);
      requestAnimationFrame(() => dialog.classList.add('is-open'));
    });
  }

  function close(dialog) {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    dialog.classList.add('is-closing');
    dialog.classList.remove('is-open');
    const done = () => {
      const panel = dialog.querySelector('.su-sizehelp__panel');
      panel.style.transition = '';
      panel.style.transform = '';
      dialog.classList.remove('is-closing');
      dialog.close();
      document.body.classList.remove('overflow-hidden');
      // Auf Touch-Geraeten den zurueckgegebenen Fokus loesen, sonst zeigt Safari einen Rahmen um den Link
      if (mobile.matches && document.activeElement && document.activeElement.blur) document.activeElement.blur();
    };
    if (reduce.matches) done();
    else setTimeout(done, 300);
  }

  // Herunterziehen auf Mobil: folgt dem Finger, schliesst ab 110px oder bei schnellem Wisch, sonst federt es zurueck
  function bindDrag(dialog) {
    const panel = dialog.querySelector('.su-sizehelp__panel');
    const body = dialog.querySelector('[data-su-sizehelp-body]');
    let startY = null;
    let fromHead = false;
    let dragging = false;
    let dy = 0;
    let t0 = 0;
    panel.addEventListener('touchstart', (e) => {
      if (!mobile.matches || e.touches.length !== 1) return;
      fromHead = !!e.target.closest('.su-sizehelp__head');
      if (!fromHead && body.scrollTop > 0) return;
      startY = e.touches[0].clientY;
      t0 = Date.now();
      dy = 0;
      dragging = false;
    }, { passive: true });
    panel.addEventListener('touchmove', (e) => {
      if (startY === null) return;
      const d = e.touches[0].clientY - startY;
      if (!dragging) {
        if (d > 6 && (fromHead || body.scrollTop <= 0)) {
          dragging = true;
          panel.style.transition = 'none';
        } else if (d < -6) {
          startY = null;
          return;
        } else {
          return;
        }
      }
      dy = Math.max(0, d);
      panel.style.transform = 'translate3d(0,' + dy + 'px,0)';
      e.preventDefault();
    }, { passive: false });
    const end = () => {
      if (startY === null) return;
      startY = null;
      if (!dragging) return;
      dragging = false;
      const speed = dy / Math.max(1, Date.now() - t0);
      if (dy > 110 || speed > 0.6) {
        panel.style.transition = 'transform 0.28s ease-out';
        panel.style.transform = 'translate3d(0,100%,0)';
        close(dialog);
      } else {
        panel.style.transition = '';
        panel.style.transform = '';
      }
    };
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-su-sizehelp-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.suSizehelpOpen);
      if (dialog) { event.preventDefault(); open(dialog); }
      return;
    }
    const closer = event.target.closest('[data-su-sizehelp-close]');
    if (closer) { close(closer.closest('dialog')); return; }
    // Klick auf den Rand ausserhalb des Fensters (das dialog-Element fuellt den Bildschirm)
    if (event.target.matches && event.target.matches('dialog.su-sizehelp')) close(event.target);
  });

  document.addEventListener('cancel', (event) => {
    if (event.target.matches && event.target.matches('dialog.su-sizehelp')) {
      event.preventDefault();
      close(event.target);
    }
  }, true);
})();
